var map = {
	"./logo1.png": 2141,
	"./logo10.png": 2377,
	"./logo2.png": 374,
	"./logo3.png": 4175,
	"./logo4.png": 6144,
	"./logo5.png": 345,
	"./logo6.png": 2162,
	"./logo7.png": 3707,
	"./logo7.svg": 2247,
	"./logo8.png": 9692,
	"./logo9.png": 1317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9763;